import React from 'react';

export function Button({
  variant = 'primary',
  children,
  onClick,
  type = 'button',
  className = ''
}) {
  const baseStyles = `
    px-4 py-2 rounded-lg font-medium transition
    focus:outline-none focus:ring-2 focus:ring-offset-1
  `;

  const variantStyles = {
    primary: `
      bg-[var(--btn-primary-bg)] text-[var(--btn-primary-text)] flex items-center justify-center  
      hover:bg-[var(--btn-primary-hover)] active:bg-[var(--btn-primary-active)]
      focus:ring-[var(--border-focus)]
    `,
    secondary: `
      bg-[var(--btn-secondary-bg)] text-[var(--btn-secondary-text)] flex items-center justify-center
      hover:bg-[var(--btn-secondary-hover)] active:bg-[var(--btn-secondary-active)]
      focus:ring-[var(--border-focus)]
    `,
    outline: `
      bg-transparent text-[var(--btn-outline-text)] border flex items-center justify-center
      border-[var(--btn-outline-border)]
      hover:bg-[var(--btn-outline-hover)] focus:ring-[var(--border-focus)]
    `
  };

  return (
    <button
      type={type}
      onClick={onClick}
      className={`${baseStyles} ${variantStyles[variant]} ${className}`}
    >
      {children}
    </button>
  );
}
